<template>
    <div>
        <div>
            <br/>
            <nav class="navbar navbar-expand-lg navbar-light" v-if="canViewDriverAll || canViewPurchases">
                <div class="ml-auto">
                    <form v-on:keypress.enter.prevent="searchRepair" class="form-inline my-2 my-lg-0">
                        <input
                            class="form-control mr-sm-2"
                            type="search"
                            v-model="search.license_plate"
                            placeholder="ทะเบียนรถ"
                            aria-label="Search"/>
                        <date-picker
                            v-model="search.date"
                            type="date"
                            :format="changeFormat"
                            :lang="lang"
                            placeholder="วันที่อัพเดต">
                        </date-picker>
                        &nbsp
                        <button @click="searchRepair"
                                class="btn btn-success my-2 my-sm-0"
                                type="button">
                            <icon name="search"></icon>
                            ค้นหา
                        </button>
                        &nbsp
                        <button @click="showImportRepairModal"
                                class="btn btn-warning my-2 my-sm-0"
                                type="button">
                            <icon name="plus"></icon>
                            เบิกเงิน
                        </button>
                        &nbsp
                        <button @click="viewreport"
                                class="btn btn-success my-2 my-sm-0"
                                type="button">
                            <icon name="print"></icon>
                            รายงานบันทึกจ่ายค่าซ่อม
                        </button>
                        &nbsp
                    </form>
                </div>
            </nav>
            <div class="col-12 table-responsive">
                <table class="table table-bordered text-center">
                    <thead>
                    <tr>
                        <th scope="col">ลำดับ</th>
                        <th scope="col">วัน/เดือน/ปี ที่เบิก</th>
                        <th scope="col">รายการ</th>
                        <th scope="col">ชื่อ-นามสกุล</th>
                        <th scope="col">ทะเบียนรถ</th>
                        <th scope="col">ยอดเงินฝาก</th>
                        <th scope="col">ยอดที่เบิก</th>
                        <th scope="col">ผู้เบิก</th>
                        <th scope="col">ผู้จ่าย</th>
                        <th scope="col">ไฟล์</th>
                        <th scope="col">แก้ไข / ลบ</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(data,index) in repair_list">
                        <td>{{ ((dataPaginate.current_page - 1) * 30) + (index + 1) }}</td>
                        <td>{{ data.date | moment("DD/MM/YYYY") }}</td>
                        <td>{{ data.list_name }}</td>
                        <td>{{ data.driver_name }}</td>
                        <td>{{ data.license_plate }}</td>
                        <td>{{ data.deposit_total | currency }}</td>
                        <td>{{ data.amount | currency }}</td>
                        <td>{{ data.driver_name }}</td>
                        <td>{{ data.payer }}</td>
                        <td>
                            <template v-if="data.slip_file">
                                <a :href="data.slip_file" target="_blank">
                                    <icon name="file"></icon>
                                    ดูไฟล์
                                </a>
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <a @click="showDeleteModal(data.id)">
                                <icon name="trash-alt"></icon>
                            </a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="repair_list.length > 0">
                <vue-pagination :pagination="dataPaginate"
                                @paginate="getRepairPage(dataPaginate.current_page)">
                </vue-pagination>
            </div>
            <br/>
            <b-modal hide-header hide-footer
                     ref="delete_data">
                <div style="text-align: center;">
                    <delete-confirm-modal @submit="deleteData">
                    </delete-confirm-modal>
                </div>
            </b-modal>
            <!--Modal import repair-->
            <b-modal
                hide-footer
                ref="import_data"
                id="edit"
                title="บันทึกการจ่ายค่าซ่อม">
                <div>
                    <div class="row text-right" v-if="form.driver">
                        <div class="col-sm-6">
                        <span style="font-size: 13px; color: red">
                        *ยอดเงินฝาก {{ form.deposit | currency }}
                        </span>
                            <br/><br/>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-sm-4 text-right">
                            <label>คนขับ</label>
                        </div>
                        <div class="col-sm-6">
                            <multiselect
                                v-model="form.driver"
                                :options="optionDriver"
                                label="name"
                                placeholder="กรุณาเลือกคนขับ"
                                :show-labels="false"
                                @input="setDriverData(form.driver)"
                                track-by="name">
                            </multiselect>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-sm-4 text-right">
                            <label>ทะเบียนรถ</label>
                        </div>
                        <div class="col-sm-6">
                            <input class="form-control"
                                   placeholder="ทะเบียนรถ"
                                   v-model="form.license_plate"
                                   :disabled="form.driver"
                                   type="text"/>
                        </div>
                    </div>
                    <div class="row form-group" v-if="form.driver && form.driver.transport_type">
                        <div class="col-sm-4 text-right">
                            <label>ประเภทรถ</label>
                        </div>
                        <div class="col-sm-6">
                            <input class="form-control"
                                   placeholder="ทะเบียนรถ"
                                   v-model="form.driver.transport_type.name"
                                   :disabled="form.driver"
                                   type="text"/>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-sm-4 text-right">
                            <label>หมายเหตุ</label>
                        </div>
                        <div class="col-sm-6">
                            <textarea class="form-control"
                                      placeholder="รายการซ่อม"
                                      v-model="form.list_name">
                            </textarea>

                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-sm-4 text-right">
                            <label>จำนวนเงินที่เบิก</label>
                        </div>
                        <div class="col-sm-6">
                            <input class="form-control"
                                   placeholder="จำนวนเงิน"
                                   v-model="form.amount"
                                   type="number"/>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-sm-4 text-right">
                            <label>วันที่เบิกเงิน</label>
                        </div>
                        <div class="col-sm-6">
                            <date-picker
                                v-model="date"
                                type="date"
                                :format="changeFormat"
                                :lang="lang"
                                placeholder="วันที่เบิกเงิน">
                            </date-picker>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-sm-4 text-right">
                            <label>ใบเสร็จค่าซ่อม</label>
                        </div>
                        <div class="col-sm-6">
                            <b-form-file placeholder="Choose a file..." @change="getPathFile">
                            </b-form-file>
                        </div>
                    </div>
                    <br/>
                    <div class="col text-center">
                        <button @click="saveImportRepair"
                                type="button"
                                class="btn btn-success">
                            <icon name="save" style="width: 25px"></icon>
                            บันทึก
                        </button>
                        &nbsp&nbsp
                        <button @click="hideImportRepairModal"
                                type="button"
                                class="btn btn-outline-secondary">
                            <icon name="times" style="width: 25px"></icon>
                            ยกเลิก
                        </button>
                    </div>
                    <br/>
                </div>
            </b-modal>
            <b-modal hide-header hide-footer ref="loading">
                <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"/>
            </b-modal>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";
import VuePagination from "../../Pagination";
import DatePicker from 'vue2-datepicker'
import moment from "moment";
import FormTextarea from "bootstrap-vue/es/components/form-textarea/form-textarea";
import {canViewDriver, canViewDriverAll, canViewPurchases,} from "../../../util/Permissions";
import DeleteConfirmModal from "../../Utility/DeleteConfirmModal";
import Loading from "../../Utility/Loading";
import {domain} from "../../../util/Constants";

export default {
    name: "repair-list",
    components: {
        Loading,
        DeleteConfirmModal,
        FormTextarea,
        VuePagination,
        Multiselect,
        DatePicker
    },
    data() {
        return {
            id: "",
            dateFormat: 'D MMM YYYY',
            delete_id: null,
            search: {
                license_plate: "",
                date: ""
            },
            date: '',
            msg: '',
            status_loading: 1,
            event_submit: false,
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/' + year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    created() {
        if (!this.id) {
            this.$store.dispatch('Repair/clearform');
        }
        this.$store.dispatch('Repair/setRepair');
        this.$store.dispatch('Driver/getAll');
        this.$store.dispatch('TransportType/setTransportTypes');
    },
    computed: {
        canViewDriver,
        canViewDriverAll,
        canViewPurchases,
        ...mapState({
            repair_list: state => {
                return state.Repair.repair_list;
            },
            optionDriver: state => {
                return state.Driver.optionDriver.filter(driver => !driver.cancel_status);
            },
            form: state => {
                return state.Repair.form
            },
            user: state => {
                return state.Auth.user
            },
            dataPaginate: state => {
                return state.Repair.dataPaginate
            },
            optionTransport: state => {
                return [
                    {
                        value: "",
                        text: "เลือกประเภทรถ"
                    },
                    ...state.TransportType.transportTypeList.map(type => ({
                        value: type.id,
                        text: type.name
                    }))
                ];
            }

        })
    },
    methods: {
        showImportRepairModal() {
            this.$refs.import_data.show();
        },
        viewreport() {
            window.open(`${domain}/tableau/reportRepair`);
        },
        hideImportRepairModal() {
            this.$refs.import_data.hide();
            this.$store.dispatch('Repair/clearform');
        },
        setDriverData(driver) {
            if (driver) {
                this.form.license_plate = driver.license_plate;
                this.form.transport_type_id = driver.transport_type_id;
                this.form.deposit = driver.deposit_total;
            } else {
                this.form.license_plate = "";
                this.form.transport_type_id = "";
                this.form.deposit = "";
            }
        },
        saveImportRepair() {
            if (!this.form.amount) {
                this.form.amount = 0;
            }
            if (!this.form.driver) {
                alert('กรุณาเลือกรายการคนขับ')
            } else if (parseFloat(this.form.deposit) < parseFloat(this.form.amount)) {
                alert('ยอดเงินคงเหลือไม่เพียงพอสำหรับเบิก')
            } else {
                this.form.transport_type_id = this.form.driver.transport_type ? this.form.driver.transport_type.id : '';
                this.$store.dispatch('Repair/save', {
                    id: this.id,
                    user: this.user.name,
                    date: this.date ? moment(this.date).format('YYYY-MM-DD') : ''
                }).then(() => {
                    this.$store.dispatch('Repair/setRepair');
                }).then(() => {
                    this.$store.dispatch('Repair/clearform');
                });
                this.hideImportRepairModal();
            }
        },
        searchRepair() {
            let date = this.search.date ? moment(this.search.date).format("YYYY-MM-DD") : '';
            let data = {
                date,
                license_plate: this.search.license_plate
            }
            this.event_submit = true;
            this.$store.dispatch('Repair/searchRepair', {
                page: 1,
                search: data
            });
        },
        fileUpload: function (event) {
            let input = event.target;
            this.form.file = input.files[0];
        },
        getPathFile: function (event) {
            let input = event.target;
            let file = input.files[0];
            //console.log(file);
            let formData = new FormData();
            formData.append('file', file);
            this.$store.dispatch("Common/getPathFile", formData).then(path => {
                this.form.slip_file = path;
            }).catch(() => {
                alert('ไม่สามารถอัพโหลดไฟล์ได้');
            });
        },
        getRepairPage(page) {
            let date = this.search.date ? moment(this.search.date).format("YYYY-MM-DD") : '';
            if (this.event_submit) {
                let data = {
                    date,
                    license_plate: this.search.license_plate
                }
                this.event_submit = true;
                this.$store.dispatch('Repair/searchRepair', {
                    page: page,
                    search: data
                });
            } else {
                this.$store.dispatch('Repair/setRepair', page);
            }
        },
        formatDates(dateOne) {
            let formattedDates = ''
            if (dateOne) {
                formattedDates = format(dateOne, this.dateFormat)
            }
            return formattedDates
        },
        showDeleteModal(id) {
            this.delete_id = id;
            this.$refs.delete_data.show();
        },
        hideDeleteModal() {
            this.$refs.delete_data.hide();
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        deleteData(val) {
            if (val) {
                this.showLoadingModal();
                this.msg = 'กำลังลบข้อมูล กรุณารอสักครู่';
                this.$store.dispatch("Repair/delete", this.delete_id).then(() => {
                    this.msg = 'ลบรายการสำเร็จ';
                    this.status_loading = 2;
                    this.getRepairPage(this.dataPaginate.current_page);
                }).catch(err => {
                    this.msg = 'ลบรายการไม่สำเร็จ กรุณาลองใหม่อีกครั้ง';
                    this.status_loading = 3;
                })
            }
            this.hideDeleteModal();

        }
    }
}
</script>

<style scoped>

</style>
